import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { getfunctionResource, getfunctionList, changeFunctionStatus } from './request.js';
export default {
  data() {
    return {
      form: {},
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '函数标识'
        },
        dataIndex: 'mark',
        key: '2',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '函数名称'
        },
        dataIndex: 'name',
        key: '3',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '4',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '5',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '操作'
        },
        key: '7',
        align: 'center',
        width: 230,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      functionMarkList: [],
      visible: false,
      quetoFileList: []
    };
  },
  created() {
    getfunctionResource({}).then(res => {
      this.functionMarkList = res;
    });
    this.getFunctionTable();
  },
  methods: {
    searchFunctionTable() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getFunctionTable();
    },
    getFunctionTable() {
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      if (this.form.mark) {
        params.mark = this.form.mark;
      }
      if (this.form.name) {
        params.name = this.form.name;
      }
      getfunctionList(params).then(res => {
        if (res && res.items) {
          this.pagination.total = res.totalNum;
          this.data = res.items;
        }
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getFunctionTable();
    },
    seeFunction() {},
    changeStatus(record) {
      let params = {
        id: record.id,
        status: record.status === 1 ? 0 : 1
      };
      this.quetoFileList = [];
      changeFunctionStatus(params).then(res => {
        if (res && Array.isArray(res) && res.length > 0) {
          this.visible = true;
          this.quetoFileList = res;
        } else {
          this.$message.destroy();
          this.$message.success(this.$t('修改成功'));
          this.data.forEach(item => {
            if (item.id === record.id) {
              item.status = item.status === 1 ? 0 : 1;
            }
          });
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};